import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Container, Button, Stack } from "@mui/material";
import { useClock } from "../components/ClockProvider";
import { ClockFormatted } from "../components/ClockFormatted";
import { AppVersion } from "../components/AppVersion";
import { useJednotkaQuery } from "../api/JsdhNotifikaceService/service/AdminMutations";
import JsdhNotifikaceService from "../api/JsdhNotifikaceService/service/JsdhNotifikaceService";

const ZadnyPoplach: React.FC = () => {
    const cas = useClock(); // sdílený čas
    const { data: jednotka } = useJednotkaQuery();

    const logoUrl = jednotka?.maLogo
        ? JsdhNotifikaceService.getJednotkaLogoUrl()
        : '/favicon.svg';

    return (
        <Container maxWidth="xl">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="80vh"
                textAlign="center"
            >
                <img
                    src={logoUrl}
                    alt="Logo jednotky"
                    style={{ maxWidth: 320, marginBottom: 24 }}
                />
                {jednotka?.nazev && (
                    <Typography variant="h2" fontWeight="bold" gutterBottom sx={{ fontSize: "4rem" }}>
                        {jednotka.nazev}
                    </Typography>
                )}
                <Typography variant="h1" fontWeight="bold" gutterBottom sx={{ fontSize: "7rem" }}>
                    Žádný aktivní poplach
                </Typography>

                {/* Aktuální čas */}
                <Typography variant="h1" color="text.secondary" sx={{ fontWeight: "bold", fontSize: "8rem" }}>
                    <ClockFormatted variant="time" options={{ hour: "2-digit", minute: "2-digit", second: "2-digit" }} />
                </Typography>

                {/* Aktuální datum */}
                <Typography variant="h5" color="text.secondary" sx={{ mt: 1, fontSize: "4rem" }}>
                    <ClockFormatted variant="date" options={{ day: "numeric", month: "numeric", year: "numeric" }} />
                </Typography>
            </Box>

            <Box mt={4} mb={2}
                 flexDirection="column"
                 alignItems="center"
                 justifyContent="center"
                 textAlign="center">
                <AppVersion />
            </Box>
        </Container>
    );
};

export default React.memo(ZadnyPoplach);
